import React, { useState, useEffect } from 'react';
import OtpInput from 'react-otp-input';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from './Navbar';
import { postNumberVerification, postOtpVerification, } from "../CertificateService";
// import {getForgotPassword} from "../../../Service/ForgotPassword/ForgotPasswordService";
import { getCertificateListForCitizen, getSummaryReport } from "../CertificateService"
// import { getOtpVerification } from "../../../Service/OTPVerification/OTPVerificationService";
const Login = (props) => {
    const { logo } = props;
    // const [otp, setOtp] = useState('');
    const [userData, setUserData] = useState('');
    const [mobileNumber, setMobileNumber] = useState();
    const [isValidMobile, setIsValidMobile] = useState(true);
    // const [otp, setOtp] = useState();
    const [isValidOtp, setIsValidOtp] = useState(true);
    const [sendOtp, setSendOtp] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [resendTimer, setResendTimer] = useState(30); // Timer for resend OTP
    //exp page********************************
    const [globalData, setGlobalData] = useState([]);

    const [otp, setOtp] = useState(); // State to store OTP input
    const [generatedOtp, setGeneratedOtp] = useState(null); // State to store generated OTP
    const [isOtpVerified, setIsOtpVerified] = useState(false); // State for success message
    const [errorMessage, setErrorMessage] = useState(""); // State for error message
    const [timer, setTimer] = useState(0); // State for timer

    const [isChecked, setIsChecked] = useState(false); // State for success message
    const [language, setLanguage] = useState("E")
    const [selectedLanguage, setSelectedLanguage] = useState("English");

    const handleLanguageChange = (event) => {
        setSelectedLanguage(event.target.value);
        console.log(`Selected Language: ${event.target.value}`);
    };
    const navigate = useNavigate();

    const onCheck = (e) => {
        setIsChecked(!isChecked); // Toggle true/false
    };

    const getFormattedDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is 0-based
        const day = String(today.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        getSummaryReport(0, 0, 0, "01.01.2024", getFormattedDate(),
        ).then(function (result) {
            const response = result?.data;
            console.log(response, "resresres")
            setGlobalData(response);
        });
    }, []);
    console.log(userData?.email, "userData")

    const onVerify = () => {

        console.log("verifyyyyyyyyyyyyyy")
        if (!otp) {
            toast.error("Please Type 4 digit OTP")
        } else {
            postOtpVerification(mobileNumber, otp, (res) => {
                console.log(res, "koko")
                if (res?.StatusCode == 0) {
                    const dataMobile = { "mobile": mobileNumber }
                    localStorage.setItem("Certificate_user", JSON.stringify(dataMobile));

                    toast.success("OTP Verified successfully")
                    navigate("/add-certificate");

                } else {
                    toast.error("Invalid Otp")
                }
            })

        }

    }


    const onSend = (e) => {
        if (!mobileNumber) {
            toast.error("Please Enter your mobile number")
        } else {
            postNumberVerification(mobileNumber, (res) => {
                console.log(res, "koko")
                if (res?.StatusCode == 0) {
                    toast.success("OTP has been send successfully")
                    setSendOtp(true)
                    startResendTimer();
                } else {
                    toast.error(res.message)
                }
            })


            // setSendOtp(true)
        }
    }

    const resendOtp = () => {
        onSend();
    };

    const startResendTimer = () => {
        setResendTimer(30); // Reset timer to 30 seconds
        const timerInterval = setInterval(() => {
            setResendTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(timerInterval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const onMobile = (e) => {
        const inputValue = e.target.value;

        // Only allow numbers and limit to 10 digits
        if (inputValue.length <= 10 && /^[0-9]*$/.test(inputValue)) {
            setMobileNumber(inputValue);
        }
    };


    const onOtp = (e) => {
        const value = e.target.value;
        const regex = /^[0-9]{4}$/;
        if (regex.test(value) || value === '') {
            setOtp(value);
            setIsValidOtp(true);
        } else {
            setIsValidOtp(false);
        }
    }

    const onStatus = () => {
        navigate(`/status-of-application`);
    }

    const onCertificateCheck = () => {
        navigate(`/certificate-check`);
    }


    const totalApply = globalData.reduce((total, item) => total + parseInt(item.apply, 10), 0);
    const totalPending = globalData.reduce((total, item) => total + parseInt(item.inProgress, 10), 0);
    const totalDownload = globalData.reduce((total, item) => total + parseInt(item.download, 10), 0);
    const totalReject = globalData.reduce((total, item) => total + parseInt(item.reject, 10), 0);


    return (
        <div className="container panel callout success" >
            <ToastContainer />



            <div className="grid-container" >

                <div
                    className="callout shadow"
                    style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.1)",
                        padding: "20px",
                        backgroundColor: "navajowhite",
                    }}
                >
                    <div
                        className=""
                        style={{
                            display: "flex", // Flexbox for alignment
                            gap: "10px", // Adds spacing between boxes
                            justifyContent: "center", // Centers all boxes horizontally
                            padding: "0px",
                        }}
                    >
                        <div
                            style={{
                                border: "2px solid #4CAF50", // Green border
                                backgroundColor: "#E8F5E9", // Light green background
                                padding: "5px",
                                borderRadius: "10px",
                                textAlign: "center",
                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                width: "150px",
                                // height: "60px" // Fixed width for uniform size
                            }}
                        >
                            <b><span style={{ color: "#4CAF50" }}>Applications Received</span></b>
                            <br />
                            <b>{totalApply}</b>
                        </div>
                        <div
                            style={{
                                border: "2px solid #2196F3", // Blue border
                                backgroundColor: "#E3F2FD", // Light blue background
                                padding: "5px",
                                borderRadius: "10px",
                                textAlign: "center",
                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                width: "150px",
                                // Fixed width for uniform size

                            }}
                        >
                            <b><span style={{ color: "#2196F3" }}>Certificate Issued</span></b>
                            <br />
                            <b>{totalDownload}</b>
                        </div>


                        <div
                            style={{
                                border: "2px solid #F44336", // Red border
                                backgroundColor: "#FFEBEE", // Light red background
                                padding: "5px",
                                borderRadius: "10px",
                                textAlign: "center",
                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                width: "150px",
                                // height: "60px" // Fixed width for uniform size

                            }}
                        >
                            <b><span style={{ color: "#F44336" }}>Application Rejected</span></b>
                            <br />
                            <b>{totalReject}</b>
                        </div>
                        <div
                            style={{
                                border: "2px solid #FFC107", // Yellow border
                                backgroundColor: "#FFFDE7", // Light yellow background
                                padding: "5px",
                                borderRadius: "10px",
                                textAlign: "center",
                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                width: "150px",
                                // height: "60px" // Fixed width for uniform size

                            }}
                        >
                            <b><span style={{ color: "#FFC107" }}>In Progress</span></b>
                            <br />
                            <b>{totalPending}</b>
                        </div>
                    </div>

                    <div
                        style={{
                            textAlign: "center",
                            marginBottom: "5px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "#333",
                            marginTop: "5px",

                        }}
                    >
                        Select Your Preferred Language
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "20px", // Adds spacing between radio buttons
                            // marginBottom: "10px",
                            // marginTop: "5px",
                        }}
                    >



                        <label
                            style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                padding: "10px",
                                border: `2px solid ${selectedLanguage === "English" ? "#4CAF50" : "#ccc"}`,
                                borderRadius: "10px",
                                backgroundColor: selectedLanguage === "English" ? "#E8F5E9" : "#f9f9f9",
                                color: selectedLanguage === "English" ? "#4CAF50" : "#000",
                                fontWeight: selectedLanguage === "English" ? "bold" : "normal",
                                boxShadow: selectedLanguage === "English" ? "0px 4px 8px rgba(0, 0, 0, 0.2)" : "none",
                            }}
                        >
                            <input
                                type="radio"
                                value="English"
                                checked={selectedLanguage === "English"}
                                onChange={handleLanguageChange}
                                style={{ display: "none" }} // Hides the default radio button
                            />
                            English
                        </label>
                        <label
                            style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                padding: "10px",
                                border: `2px solid ${selectedLanguage === "Bengali" ? "#2196F3" : "#ccc"}`,
                                borderRadius: "10px",
                                backgroundColor: selectedLanguage === "Bengali" ? "#E3F2FD" : "#f9f9f9",
                                color: selectedLanguage === "Bengali" ? "#2196F3" : "#000",
                                fontWeight: selectedLanguage === "Bengali" ? "bold" : "normal",
                                boxShadow: selectedLanguage === "Bengali" ? "0px 4px 8px rgba(0, 0, 0, 0.2)" : "none",
                            }}
                        >
                            <input
                                type="radio"
                                value="Bengali"
                                checked={selectedLanguage === "Bengali"}
                                onChange={handleLanguageChange}
                                style={{ display: "none" }} // Hides the default radio button
                            />
                            Bengali
                        </label>
                        <label
                            style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                padding: "10px",
                                border: `2px solid ${selectedLanguage === "Nepali" ? "#FFC107" : "#ccc"}`,
                                borderRadius: "10px",
                                backgroundColor: selectedLanguage === "Nepali" ? "#FFFDE7" : "#f9f9f9",
                                color: selectedLanguage === "Nepali" ? "#FFC107" : "#000",
                                fontWeight: selectedLanguage === "Nepali" ? "bold" : "normal",
                                boxShadow: selectedLanguage === "Nepali" ? "0px 4px 8px rgba(0, 0, 0, 0.2)" : "none",
                            }}
                        >
                            <input
                                type="radio"
                                value="Nepali"
                                checked={selectedLanguage === "Nepali"}
                                onChange={handleLanguageChange}
                                style={{ display: "none" }} // Hides the default radio button
                            />
                            Nepali
                        </label>
                    </div>


                    <b><h1 className="text-center" style={{ color: "green" }}>APPLICATION TO GRAM PANCHAYAT FOR CERTIFICATE</h1></b>
                    <p className='panel callout warning' style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        padding: "10px",
                        backgroundColor: "#fff3d9",
                    }}>
                        <b onClick={onStatus}>
                            <Link
                                style={{
                                    animation: "blink 1.2s infinite",
                                    textDecoration: "none",
                                    color: "#2996f1",
                                }}
                            >
                                👉🏽 Application Status and Certificate Download
                            </Link>
                        </b>
                        <b style={{ marginLeft: "20px" }} onClick={onCertificateCheck}>
                            <Link
                                style={{
                                    animation: "blink 1s infinite",
                                    textDecoration: "none",
                                    color: "#2996f1",
                                }}
                            >
                                👉🏽 Search by Certificate No.
                            </Link>
                        </b>

                        <br></br>

                        <b>
                            Citizens of rural Bengal can apply for the following certificates free of
                            charge at their respective Gram Panchayat:</b>
                    </p>

                    <div className='grid-x grid-padding-x'>
                        <div className='cell large-12'>
                            <style>
                                {`.ist-ul li{font-size: inherit;float: left;margin-right: 50px;}`}
                            </style>
                            <ul className='ist-ul' style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "1.6" }}>
                                <b><li>Residential</li>
                                    <li>Character</li>
                                    <li>Income</li>
                                    <li>Same Person</li>
                                    <li>Distance</li>
                                    <li>Caste Authentication</li>
                                    <li>Unmarried</li>
                                </b>
                            </ul>
                        </div>
                    </div>

                    {/* //ENGLISH// */}

                    {selectedLanguage === "English" ?
                        <p className='panel callout warning shadow' style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "10px",
                            backgroundColor: "#fff3d9",
                        }}>
                            <b>A passport-size photograph (jpg format within 100 KB) along with following two documents for address and identity verification (PDF within 2 MB) will have to be uploaded at the time of submission.</b>
                        </p> : ""}

                    {/* //BENGALI// */}

                    {selectedLanguage === "Bengali" ?
                        <p className='panel callout warning shadow' style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "10px",
                            backgroundColor: "#fff3d9",
                        }}>
                            <b>সাবমিশনের সময় একটি পাসপোর্ট সাইজের ফটোগ্রাফ (jpg ফরম্যাটে 100 KB এর মধ্যে) এবং নিম্নলিখিত ঠিকানা ও পরিচয় যাচাইকরণের জন্য দুটি নথি (PDF ফরম্যাটে 2 MB এর মধ্যে) আপলোড করতে হবে।</b>
                        </p> : ""}

                    {/* //NEPALI// */}

                    {selectedLanguage === "Nepali" ?
                        <p className='panel callout warning shadow' style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "10px",
                            backgroundColor: "#fff3d9",
                        }}>
                            <b>सबमिशनको समयमा पासपोर्ट साइजको फोटोग्राफ (jpg फर्म्याटमा १०० KB भित्र) र निम्नलिखित ठेगाना र पहिचान प्रमाणीकरणका लागि दुईवटा कागजात (PDF भित्र २ MB) अपलोड गर्नुपर्नेछ।</b>
                        </p> : ""}

                    {/* //ENGLISH// */}

                    {selectedLanguage === "English" ?
                        <div className='grid-x grid-padding-x'>
                            <div className='large-6 cell'>
                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "1.6" }}>
                                    <li>Documents related to proof of caste from immediate or extended family members must be merged into a single PDF file (Mandatory for Caste Authentication only)</li>
                                    <li>Certificate Issued by Gram Sansad Member</li>

                                    <li>Aadhaar Card</li>
                                    <li>Passport</li>
                                    <li>Driving License</li>
                                    <li>Election Commission Voter ID Card</li>
                                    <li>Ration Card with address</li>
                                    <li>CGHS/ECHS Card</li>
                                    <li>Certificate of address with photo from Govt. recognized educational institutions (for students only)</li>
                                </ul>

                            </div>
                            <div className='large-6 cell'>
                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "1.6" }}>


                                    <li>Income Tax PAN Card</li>
                                    <li>Current passbook of Post Office/any scheduled bank having photo</li>
                                    <li>Photo Identity Card (of Central Govt./PSU or State Govt./PSU only)</li>
                                    <li>MGNREGA card issued by Govt.</li>
                                    <li>Photo Identity Card issued by Govt. recognized educational institutions (for students only)</li>
                                    <li>Pensioner Card having photo and Address</li>
                                    <li>Kissan Passbook having photo and Address</li>
                                    <li>Current Financial Year Tax receipt</li>
                                    <li>Other Documents related to desired certificate</li>
                                </ul>
                            </div>
                        </div> : ""}

                    {/* //BENGALI// */}

                    {selectedLanguage === "Bengali" ?
                        <div className='grid-x grid-padding-x'>
                            <div className='large-6 cell'>
                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "1.6" }}>
                                    <li>পরিবারের সদস্যদের থেকে জাতির প্রমাণ সম্পর্কিত নথি একক PDF ফাইলে সংযুক্ত করতে হবে (শুধুমাত্র জাতি প্রমাণের জন্য বাধ্যতামূলক)</li>
                                    <li>গ্রাম সংসদ সদস্যের দ্বারা জারি করা সার্টিফিকেট</li>
                                    <li>আধার কার্ড</li>
                                    <li>পাসপোর্ট</li>
                                    <li>ড্রাইভিং লাইসেন্স</li>
                                    <li>নির্বাচন কমিশন ভোটার আইডি কার্ড</li>
                                    <li>রেশন কার্ড</li>
                                    <li>CGHS/ECHS কার্ড</li>
                                    <li>সরকারি স্বীকৃত শিক্ষাপ্রতিষ্ঠান থেকে ছবিসহ ঠিকানার সার্টিফিকেট (শুধুমাত্র শিক্ষার্থীদের জন্য)</li>
                                </ul>

                            </div>
                            <div className='large-6 cell'>
                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "1.6" }}>


                                    <li>আয়কর প্যান কার্ড</li>
                                    <li>ছবিসহ পোস্ট অফিস/কোনও নির্ধারিত ব্যাংকের বর্তমান পাসবই</li>
                                    <li>ছবি পরিচয়পত্র (শুধুমাত্র কেন্দ্রীয় সরকার/PSU বা রাজ্য সরকার/PSU এর)</li>
                                    <li>সরকার কর্তৃক জারি করা MGNREGA কার্ড</li>
                                    <li>সরকারি স্বীকৃত শিক্ষাপ্রতিষ্ঠান কর্তৃক জারি করা ছবির পরিচয়পত্র (শুধুমাত্র শিক্ষার্থীদের জন্য)</li>
                                    <li>ছবিসহ পেনশনভোগী কার্ড এবং ঠিকানা</li>
                                    <li>ছবিসহ এবং ঠিকানাসহ কৃষাণ পাসবই</li>
                                    <li>বর্তমান অর্থ বছরের ট্যাক্স রসিদ</li>
                                    <li>কাঙ্ক্ষিত সার্টিফিকেট সম্পর্কিত অন্যান্য নথি</li>
                                </ul>
                            </div>
                        </div> : ""}

                    {/* //NEPALI// */}

                    {selectedLanguage === "Nepali" ?
                        <div className='grid-x grid-padding-x'>
                            <div className='large-6 cell'>
                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "1.6" }}>
                                    <li>परिवारका सदस्यहरूबाट जातिको प्रमाण सम्बन्धित कागजातलाई एकल PDF फाइलमा संलग्न गर्नु पर्नेछ (मात्र जाति प्रमाणको लागि बाध्यकारी) </li>
                                    <li>ग्राम संसद सदस्यद्वारा जारी गरिएको प्रमाणपत्र </li>

                                    <li>आधार कार्ड </li>
                                    <li>पासपोर्ट</li>
                                    <li>ड्राइभिङ लाइसेन्स</li>
                                    <li>निर्वाचन आयोगको मतदाता परिचय पत्र </li>
                                    <li>राशन कार्ड </li>
                                    <li>CGHS/ECHS कार्ड </li>
                                    <li>सरकारी मान्यता प्राप्त शैक्षिक संस्थाबाट फोटोसहित ठेगानाको प्रमाणपत्र (मात्र विद्यार्थीहरूको लागि)</li>
                                </ul>

                            </div>
                            <div className='large-6 cell'>
                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "1.6" }}>


                                    <li>आयकर प्यान कार्ड </li>
                                    <li>फोटोसहित पोस्ट अफिस/कुनै पनि निर्धारित बैंकको वर्तमान पासबुक </li>
                                    <li>फोटो पहिचान पत्र (केवल केन्द्रीय सरकार/PSU वा राज्य सरकार/PSU का)</li>
                                    <li>सरकारद्वारा जारी गरिएको MGNREGA कार्ड</li>
                                    <li>सरकारी मान्यता प्राप्त शैक्षिक संस्थाबाट जारी गरिएको फोटो परिचय पत्र (मात्र विद्यार्थीहरूको लागि)</li>
                                    <li>फोटो र ठेगानासहित पेन्शन कार्ड</li>
                                    <li>फोटो र ठेगानासहित किसान पासबुक</li>
                                    <li>वर्तमान आर्थिक वर्षको कर रसिद</li>
                                    <li>इच्छित प्रमाणपत्र सम्बन्धित अन्य कागजात</li>
                                </ul>
                            </div>
                        </div> : ""}

                    {/* //ENGLISH// */}

                    {selectedLanguage === "English" ?
                        <div>
                            <p className='panel callout warning shadow' style={{
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                padding: "8px",
                                backgroundColor: "#fff3d9",
                            }}>
                                <b>Certificate will be Disposed within apprx. 7 working days and certificate is valid for 6 Months.</b><br></br>
                                <b
                                    style={{
                                        animation: "blink 1s infinite",
                                        textDecoration: "none",
                                        color: "red",
                                    }}>
                                    Since the Gram Panchayat has just started issuing different certificates online, it may take additional time initially to  issue Certificate for some Gram Panchayats.
                                </b>
                            </p>
                            <p className='panel callout warning' style={{
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                padding: "6px",
                                backgroundColor: "#fff3d9",
                            }}>
                                <b>
                                    <a
                                        href="https://helpdesk.wbprd.in/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            animation: "blink 1s infinite",
                                            textDecoration: "none",
                                            color: "black",
                                        }}
                                    >
                                        👉🏽 For any technical issues, please lodge a request for help at the Panchayat Helpdesk
                                    </a>
                                </b>




                            </p>
                        </div> : ""}

                    {/* //BENGALI// */}

                    {selectedLanguage === "Bengali" ?
                        <div>
                            <p className='panel callout warning shadow' style={{
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                padding: "8px",
                                backgroundColor: "#fff3d9",
                            }}>
                                <b>সার্টিফিকেট প্রায় ৭ কার্যদিবসের মধ্যে নিষ্পত্তি করা হবে এবং সার্টিফিকেটটি ৬ মাসের জন্য বৈধ।</b><br></br>
                                <b
                                    style={{
                                        animation: "blink 1s infinite",
                                        textDecoration: "none",
                                        color: "red",
                                    }}>
                                    যেহেতু গ্রাম পঞ্চায়েত বিভিন্ন সার্টিফিকেট অনলাইনে ইস্যু করা শুরু করেছে, কিছু গ্রাম পঞ্চায়েতের জন্য প্রথমে সার্টিফিকেট ইস্যু করতে অতিরিক্ত সময় লাগতে পারে।
                                </b>
                            </p>
                            <p className='panel callout warning' style={{
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                padding: "6px",
                                backgroundColor: "#fff3d9",
                            }}>
                                <b>
                                    <a
                                        href="https://helpdesk.wbprd.in/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            animation: "blink 1s infinite",
                                            textDecoration: "none",
                                            color: "black",
                                        }}
                                    >
                                        👉🏽 যে কোনও কারিগরি সমস্যার জন্য, অনুগ্রহ করে পঞ্চায়েত হেল্পডেস্কে সাহায্যের অনুরোধ জমা দিন।
                                    </a>
                                </b>




                            </p>
                        </div> : ""}

                    {/* //NEPALI// */}

                    {selectedLanguage === "Nepali" ?
                        <div>
                            <p className='panel callout warning shadow' style={{
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                padding: "8px",
                                backgroundColor: "#fff3d9",
                            }}>
                                <b>प्रमाणपत्र करिब ७ कार्यदिवस भित्र निष्पादन गरिनेछ र प्रमाणपत्र ६ महिनाको लागि मान्य हुनेछ।</b><br></br>
                                <b
                                    style={{
                                        animation: "blink 1s infinite",
                                        textDecoration: "none",
                                        color: "red",
                                    }}>
                                    किनभने ग्राम पंचायतहरूले विभिन्न प्रमाणपत्रहरू अनलाइन जारी गर्न थालेकोले, केही ग्राम पंचायतहरूको लागि शुरूमा प्रमाणपत्र जारी गर्न थप समय लाग्न सक्छ।
                                </b>
                            </p>
                            <p className='panel callout warning' style={{
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                padding: "6px",
                                backgroundColor: "#fff3d9",
                            }}>
                                <b>
                                    <a
                                        href="https://helpdesk.wbprd.in/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            animation: "blink 1s infinite",
                                            textDecoration: "none",
                                            color: "black",
                                        }}
                                    >
                                        👉🏽 कुनै पनि प्राविधिक समस्याको लागि, कृपया पंचायत हेल्पडेस्कमा सहयोगको अनुरोध प्रस्तुत गर्नुहोस्।
                                    </a>
                                </b>




                            </p>
                        </div> : ""}

                    <div
                        className="callout shadow"
                        style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "20px",
                            backgroundColor: "#fff3d9",
                        }}
                    >
                        <form>
                            <style>
                                {`
                           [type=checkbox] {
                             margin: 0 3px 0 0 !important;
                                                    }
                                       `}
                            </style>
                            <label style={{ display: "flex", alignItems: "center" }}>
                                <input
                                    type="checkbox"
                                    style={{ marginRight: "3px !important" }}
                                    checked={isChecked}
                                    onChange={onCheck}
                                />
                                <b>I would like to apply to the Gram Panchayat Pradhan for a certificate, and all the necessary documents are ready for upload.</b>
                            </label>
                            {isChecked == true ?
                                <button type="button" className="btn" onClick={() => setShowModal(true)}>
                                    Proceed
                                </button> : ""}
                        </form>
                    </div>

                </div>
                {/* <h2 className="text-center bold" style={{ color: "green" }}>Our site is currently undergoing scheduled maintenance to improve your experience. We apologize for any inconvenience this may cause. Please check back soon. Thank you for your patience and understanding.</h2>

                <h2 className="text-center bold" style={{ color: "red" }}>Site will be resumed on 22-01-2025 at 4.00 PM.</h2> */}



                {showModal && (
                    <div
                        className="modal-overlay"
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 1000,
                        }}
                    >
                        <div
                            className="card"
                            style={{
                                width: "400px",
                                backgroundColor: "#fff",
                                padding: "20px",
                                borderRadius: "8px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                position: "relative",
                            }}
                        >
                            <div className="header">
                                <h1 style={{ color: "green" }}>Citizen Corner</h1>
                                <h2 style={{ color: "black" }}>Citizen Sign Up</h2>
                            </div>
                            <div className="content">

                                <button
                                    style={{
                                        position: "absolute",
                                        top: "10px",
                                        right: "10px",
                                        background: "none",
                                        border: "none",
                                        fontSize: "20px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setShowModal(false)}
                                >
                                    &times;
                                </button>
                                <div className="otp-form">

                                    <input
                                        type="number"
                                        id="userOTP"
                                        placeholder="Enter Mobile Number"
                                        maxLength={10}
                                        value={mobileNumber}
                                        onChange={onMobile}

                                        style={{ marginRight: "10px", padding: "5px" }}
                                    />
                                </div>
                                {sendOtp ?
                                    <div className="otp-form">
                                        <input
                                            type="text"
                                            id="userOTP"
                                            placeholder="Enter OTP"
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value)}

                                            style={{ marginRight: "10px", padding: "5px" }}
                                        />
                                        <button
                                            onClick={onVerify}

                                        >
                                            Verify & Proceed
                                        </button>
                                    </div> : ""}

                                {sendOtp ? "" :
                                    <button id="generateBtn" onClick={onSend}>
                                        Generate OTP
                                    </button>}

                                {sendOtp ?

                                    <div style={{ marginTop: "10px" }}>
                                        <button
                                            id="generateBtn"
                                            onClick={resendOtp}
                                            style={{
                                                padding: "10px",
                                                width: "100%",
                                                backgroundColor: resendTimer > 0 ? "#ccc" : "#007bff",
                                                color: "#fff",
                                                cursor: resendTimer > 0 ? "not-allowed" : "pointer",
                                            }}
                                            disabled={resendTimer > 0}
                                        >
                                            {resendTimer > 0
                                                ? `Resend OTP in ${resendTimer}s`
                                                : "Resend OTP"}
                                        </button>
                                    </div> : ""}

                                {isOtpVerified && (
                                    <div className="success-message" style={{ color: "green", marginTop: "10px" }}>
                                        <i className="fas fa-check"></i>
                                        <p>Congratulations! OTP is Verified!</p>
                                    </div>
                                )}


                                {errorMessage && (
                                    <div className="error-message" style={{ color: "red", marginTop: "10px" }}>
                                        {errorMessage}
                                    </div>
                                )}


                                {generatedOtp && timer > 0 && (
                                    <div className="timer" style={{ marginTop: "10px" }}>
                                        OTP expires in <b>{timer} seconds</b>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </div>
    )
}



export default Login